var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IFrameSizeEmitter',_vm._b({},'IFrameSizeEmitter',_vm.data,false))
}
var staticRenderFns = []

export { render, staticRenderFns }